import Phaser from "phaser";

export default class Loading {
  currentScene;
  constructor(scene) {
    this.currentScene = scene;
  }

  progressBar() {
    this.currentScene.load.image("bg");
    this.currentScene.add.image(0, 0, "background").setOrigin(0, 0);

    let blackHover = this.currentScene.add.graphics();
    blackHover.fillStyle(0x000000, 1);
    blackHover.fillRect(0, 0, 1920, 1080);
    let progressBox = this.currentScene.add.graphics();
    let progressBar = this.currentScene.add.graphics();

    progressBox.fillStyle(0xffffff, 0.3);
    progressBox.fillRect(800, 515, 320, 50);

    this.currentScene.load.on("progress", function(value) {
      progressBar.clear();
      progressBar.fillStyle(0xffffff, 1);
      progressBar.fillRect(810, 525, 300 * value, 30);
    });

    this.currentScene.load.on("complete", () => {
      progressBar.destroy();
      progressBox.destroy();
      blackHover.destroy();
    });

    this.currentScene.add
      .text(0.5 * 1920, 0.45 * 1080, "Loading ...", {
        fontSize: "35px",
        fontWeight: "bold"
      })
      .setOrigin(0.5, 0.5);
  }
}
